import { ActiveTask } from '@litlingo/client';
import ConfirmModal from 'components/ConfirmModal';
import { RELOAD_ICON, TRASH_ICON } from 'constants/commonIcons';
import { upperFirst } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteTaskByJob, resetTaskByJob } from 'actions/tasks';
import daysAgo from 'components/utils/daysAgo';

type ComponentProps = {
  task: ActiveTask;
};

const TaskListItem: React.FC<ComponentProps> = ({ task }) => {
  const dispatch = useDispatch();

  const [isDeletingTask, setIsDeletingTask] = React.useState(false);

  const toggleConfirmModal = (): void => {
    setIsDeletingTask(!isDeletingTask);
  };

  const handleRemoveTask = (): void => {
    dispatch(deleteTaskByJob({ jobId: task.job_uuid }));
    toggleConfirmModal();
  };

  const handleResetTask = (): void => {
    dispatch(resetTaskByJob({ jobId: task.job_uuid }));
  };

  return (
    <tr className="table-row border-t border-gray-200 align-middle hover:bg-litlingo-gray-0">
      <td className="table-wrapper__new-td pl-2">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {task.job_uuid}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {task.comms_count}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {upperFirst(task.block_status)}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {task.blocks_count}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {/* @ts-ignore */}
          {task.customer_name}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {/* @ts-ignore */}
          {task.created_by_name}
        </div>
      </td>

      <td className="table-wrapper__new-td pl-0">
        <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
          {/* @ts-ignore */}
          {daysAgo(task.created_at)}
        </div>
      </td>
      <td className="table-wrapper__new-td pl-0">
        <button
          type="button"
          className="mr-4 w-5 h-5"
          data-testid="reset-task-button"
          onClick={handleResetTask}
        >
          {RELOAD_ICON}
        </button>
        <button
          type="button"
          className="mr-4 w-5 h-5"
          data-testid="delete-task-button"
          onClick={toggleConfirmModal}
        >
          {TRASH_ICON}
        </button>
        {isDeletingTask && (
          <ConfirmModal
            text="Are you sure you want to delete this task?"
            okButtonText="Yes"
            cancelButtonText="No"
            okButtonOnClick={handleRemoveTask}
            toggleShowModal={toggleConfirmModal}
          />
        )}
      </td>
    </tr>
  );
};

export default TaskListItem;
